import { client } from '../utils/fetch';
import { Location, LocationMapping } from '../types/Locations';

const END_POINT = 'locations';

export const getLocations = async (
  storeId: string
): Promise<Location[]> => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  try {
    const response = await client.get<Location[]>(
      `${END_POINT}?store_id=${storeId}`,
      headers
    );
    return response;
  } catch (error) {
    console.error("Error fetching locations:", error);
    throw error;
  }
};

export const getLocationMappings = async (
  storeId: string,
  locationCode?: string
): Promise<LocationMapping[]> => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  const params = new URLSearchParams();
  params.append('store_id', storeId);
  if (locationCode) {
    params.append('location_code', locationCode);
  }

  try {
    const response = await client.get<LocationMapping[]>(
      `${END_POINT}/mappings?${params.toString()}`,
      headers
    );
    return response;
  } catch (error) {
    console.error("Error fetching location mappings:", error);
    throw error;
  }
};

export interface AssignLocationRequest {
  location_id: number;
  location_code: string;
  store_id: string;
  sensor_id?: number;
  display_id?: number;
  label_id?: string;
}

export const assignLocation = async (
  assignData: AssignLocationRequest
): Promise<{ message: string }> => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  console.log('assignData', assignData);

  try {
    const response = await client.post<{ message: string }>(
      `${END_POINT}/assign`,
      assignData,
      headers
    );
    return response;
  } catch (error) {
    console.error("Error assigning location:", error);
    throw error;
  }
}; 

export const unassignLocation = async (
  unassignData: AssignLocationRequest
): Promise<{ message: string }> => {

  console.log('unassignData', unassignData);

  try {
    const response = await client.delete<{ message: string }>(
      `${END_POINT}/unassign`,
      unassignData
    );
    return response;
  } catch (error) {
    console.error("Error assigning location:", error);
    throw error;
  }
}; 

export interface AddLocation {
  store_id: string;
  location_code: string;
}

export const addLocation = async (
  addData: AddLocation
): Promise<{ message: string }> => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  console.log('addData', addData);

  try {
    const response = await client.post<{ message: string }>(
      `${END_POINT}/add`,
      addData,
      headers
    );
    return response;
  } catch (error) {
    console.error("Error adding location:", error);
    throw error;
  }
}; 

export interface DeleteLocation {
  id: number;
  store_id: string;
  location_code: string;
}

export const deleteLocation = async (
  deleteData: DeleteLocation
): Promise<{ message: string }> => {

  console.log('deleteData', deleteData);

  try {
    const response = await client.delete<{ message: string }>(
      `${END_POINT}/delete`,
      deleteData
    );
    return response;
  } catch (error) {
    console.error("Error deleting location:", error);
    throw error;
  }
}; 